import request from "./axiosConfig";

/**
 * 提交用户志愿模拟填报
 */
export function submitCollegeApplication(data) {
  return request({
    url: "/interface/collegeapplication/add",
    method: "post",
    data: data,
  });
}